module.exports = __webpack_public_path__ + "img/img_index_banner_x5@2x.6feeaf33.png";